import { Controller } from "@hotwired/stimulus";

export default class NormReplaceModalController extends Controller {
  static targets = ["dialog", "affectedCount", "frame"];
  static values = { resetUrl: String };

  // Re-open the dialog after a Turbo Frame swap (step navigation, error re-render).
  // Guard against the post-redirect case where the frame is empty and has no dialog.
  // Bound as an arrow function so `this` is correct when used as an event listener.
  #handleFrameLoad = () => {
    if (this.#isOpen && this.hasDialogTarget) this.dialogTarget.showModal();
  };

  #isOpen = false;

  connect() {
    this.frameTarget.addEventListener(
      "turbo:frame-load",
      this.#handleFrameLoad,
    );
  }

  disconnect() {
    this.frameTarget.removeEventListener(
      "turbo:frame-load",
      this.#handleFrameLoad,
    );
  }

  open() {
    this.#isOpen = true;
    this.dialogTarget.showModal();
  }

  close() {
    this.#isOpen = false;
    this.dialogTarget.close();
    // Navigate to the reset URL (question category templates index)
    if (this.hasResetUrlValue) {
      this._navigate(this.resetUrlValue);
    }
  }

  // Extracted for testability — jsdom does not allow patching window.location.href.
  // Prefixed with _ to signal internal use only.
  _navigate(url) {
    window.location.href = url;
  }

  // Reads data-count from the selected <option> and updates the affected-count
  // label in place — no form submission, no frame swap, dialog stays open.
  updateAffectedCount(event) {
    const selected = event.target.selectedOptions[0];
    const count = selected
      ? Number.parseInt(selected.dataset.count ?? "0", 10)
      : 0;
    const label = this.affectedCountTarget;
    const template = label.dataset.countTemplate ?? "";

    if (!selected?.value) {
      label.classList.add("hidden");
      return;
    }

    label.textContent = template.replace("__COUNT__", count);
    label.classList.remove("hidden");
  }
}
